import React from 'react';
import { Navigation, Plane, Factory, Trophy, Building2, Train } from 'lucide-react';
import { industries } from '../data/mock';

const Industries = () => {
  const iconMap = {
    Highway: Navigation,
    Plane: Plane,
    Factory: Factory,
    Trophy: Trophy,
    Building2: Building2,
    TrainFront: Train
  };

  return (
    <section id="industries" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4 tracking-tight">
            Industries We <span className="text-blue-900">Serve</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-900 to-blue-500 mx-auto mb-6 rounded-full"></div>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto font-medium leading-relaxed">
            Trusted lighting partner across diverse sectors delivering reliable, high-performance solutions for critical infrastructure.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {industries.map((industry) => {
            const Icon = iconMap[industry.icon];
            return (
              <div
                key={industry.id}
                className="bg-white rounded-3xl p-8 shadow-[0_4px_20px_rgb(0,0,0,0.03)] hover:shadow-[0_10px_40px_rgb(0,0,0,0.08)] transition-all duration-500 hover:-translate-y-2 border border-blue-50/50 hover:border-blue-100 group relative overflow-hidden"
              >
                {/* Subtle Background Accent */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-50 to-transparent rounded-bl-full opacity-50 group-hover:scale-110 transition-transform duration-500"></div>

                <div className="flex items-start justify-between mb-6 relative z-10">
                  <div className="w-16 h-16 bg-blue-50 border border-blue-100 rounded-2xl flex items-center justify-center group-hover:bg-blue-600 transition-colors duration-500 shadow-sm group-hover:shadow-[0_4px_20px_rgba(37,99,235,0.3)]">
                    <Icon className="text-blue-700 group-hover:text-white transition-colors duration-500" size={28} />
                  </div>
                  <div className="text-right">
                    <div className="text-3xl font-extrabold text-gray-900 group-hover:text-blue-900 transition-colors">{industry.projects}</div>
                    <div className="text-xs font-bold text-gray-400 uppercase tracking-wider">Completed</div>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-800 transition-colors relative z-10">
                  {industry.name}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {industry.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-white rounded-2xl shadow-lg p-8 max-w-3xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-3">
              Your Industry Not Listed?
            </h3>
            <p className="text-gray-600 mb-6">
              We adapt our solutions to meet diverse project requirements across all sectors requiring professional outdoor and industrial lighting systems.
            </p>
            <a
              href="#contact"
              className="inline-flex items-center text-blue-900 font-semibold hover:text-blue-700 transition-colors"
            >
              Contact us to discuss your specific needs
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
